import { getStorage } from '@/utils/helpers/storage'
// export const checkAuth = (value) => {
// let sysPermissionList = getStorage("sysPermissionList");
// let arr = sysPermissionList.filter((item) => {
//     return item.permission === value;
// });
// return true;
// };

//权限检查方法
export function checkPermission (data) {
  // return true
  if(!data || data.length===0) return true
  let isExist = false
  let permissionInfo = getStorage('permissionInfo')
  isExist = data.some(item => {
    return permissionInfo.some(value => {
      return value.permission === item
    })
  })
  return isExist
}
export const hasPermission = {
  install(Vue) {
    //自定义指令v-has：按钮隐藏
    Vue.directive('has-show', {
      mounted(el, binding, vnode) {
        if (!checkPermission(binding.value)) {
          el.style.display = 'none'
        }
      }
    })
  }
}
